import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import { useNavigate } from "react-router-dom";
import { makePostRequest } from "../utils/api";
import { urls } from "../utils/urls";
import toast, { Toaster } from "react-hot-toast";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import LinkButton from "../components/geriactive/utils/LinkButton";

function ForgotYourPassword() {
  const [formErrors, setFormErrors] = useState(false);
  const [userData, setUserData] = useState({
    email: "",
  });
  const [errorText, setErrorText] = useState("");
  const navigate = useNavigate();

  const handleUser = (e) => {
    setUserData(() => {
      return { email: e.target.value.toLowerCase() };
    });
  };

  const handlePasswordReset = async (data) => {
    data.preventDefault();
    setFormErrors(false);

    if (userData.email === "") {
      setErrorText(`Please enter an Email.`);
      setFormErrors(true);
    }

    if (userData.email !== "") {
      const response = await makePostRequest(
        urls.forgotYourPassword,
        userData,
        {}
      );
      if (response.status !== 200) {
        setFormErrors(true);
        setErrorText(
          `Your Email may be incorrect.
          If you need assistance please contact your administration.`
        );
      }
      if (response.status === 200) {
        setFormErrors(true);
        setErrorText(
          `Thank you for using our password reset utility. The link to reset your password has been sent to your email.`
        );
      }
    }
  };

  const copyText = () => {
    console.log("here");
    navigator.clipboard.writeText("Support@GeriActive.com");
    toast("The support email has been copied to your clipboard!", {
      duration: 4000,
      position: "bottom-center",
    });
  };

  return (
    <Container
      style={{
        display: "flex",
        alignItems: "center",
        textAlign: "left",
        minHeight: window.innerHeight,
      }}
    >
      <Card
        style={{
          width: "500px",
          margin: "auto",
          padding: "25px",
          verticalAlign: "middle",
        }}
      >
        <LinkButton
          style={{ width: "125px" }}
          url="/login"
          title="Back to home"
          buttonFontSize="12px"
        />
        <br />
        <Form onSubmit={handlePasswordReset}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter Email"
              onChange={handleUser}
            />
            <Form.Text className="text-muted">
              Please enter the Email that you log in with.
            </Form.Text>
          </Form.Group>

          {formErrors ? (
            <Card style={{ marginBottom: "15px" }}>
              <Card.Body style={{ color: "red", fontSize: "12px" }}>
                {errorText}
              </Card.Body>
            </Card>
          ) : (
            ""
          )}

          <div>
            <Button variant="primary" type="submit">
              Submit
            </Button>
            <Button
              style={{
                color: "#dfdfdf",
                position: "absolute",
                right: "25px",
                bottom: "29px",
              }}
              size="sm"
              variant="info"
              onClick={copyText}
            >
              Need Help? - <b>Click here!</b>
            </Button>
          </div>
        </Form>
      </Card>
      <Toaster />
    </Container>
  );
}

export default ForgotYourPassword;
